import http from "@/services/http";
import httpForm from "@/services/httpForm"

export const supplier = () => {
  async function list() {
    const {data} = await http.get('/supplier/list');
    return data;
  }

  async function linkItem(supplierId, itemId) {
    try {
      const {data} = await http.post('/supplier/linkitem', { id_item: itemId, id_supplier: supplierId });
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function store(itemFormData) {
    const response = await httpForm.post('/supplier/store', itemFormData);
    return response.data;
  }

  async function delet(id) {
    await http.put('/supplier/delete/'+id, {});
    return true;
  }

  async function update(itemFormData) {
    const response = await httpForm.post('/supplier/edit', itemFormData);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/supplier/getOne/'+id);
    return data;
  }

  return {list, store, delet, update,getOne, linkItem};
}